// extracted by mini-css-extract-plugin
module.exports = {"container":"Loader_container__3dqWx","loader":"Loader_loader__26qA1"};